export default __webpack_public_path__ + "4cd0e28dbd733f54bc6512bf036fb9b3.svg";